import { combineReducers } from 'redux';

import complaints from '../complaints/state';
import complaintSuggestions from '../complaints/state/suggestions';
import complaintsSearch from '../complaints/state/search';
import patientHistory from '../patientHistory/state/index';
import patientMedicalRecords from '../patientInfo/state/patient';
import saveCurrentRecord from './saveReducer';
import eventStatus from './eventStatusReducer';

const currentRecord = combineReducers({
  complaints,
  patientHistory,
});

const reducer = combineReducers({
  currentRecord,
  saveCurrentRecord,
  eventStatus,
  suggestions: combineReducers({
    complaints: complaintSuggestions,
  }),
  search: combineReducers({
    complaints: complaintsSearch,
  }),
  patient: patientMedicalRecords,
});

export default reducer;

export type MedicalRecordsState = ReturnType<typeof reducer>;
export interface StateTree {
  medicalRecords: MedicalRecordsState;
}

export type CurrentRecordState = ReturnType<typeof currentRecord>;
